import { Injectable } from '@angular/core';
import Bugsnag, { Client } from '@bugsnag/js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BugsnagService {
  private _bugsnagClient: Client;

  constructor() {
    this._bugsnagClient = Bugsnag.start({
      apiKey: environment.bugsnagApiKey,
      appVersion: '0.1.0',
    });
  }

  /**
   * Get the Bugsnag client instance
   */
  get client() {
    return this._bugsnagClient;
  }

  /**
   * Manually notify Bugsnag of an error
   */
  notify(error: Error, callback?: (event: any) => void) {
    this._bugsnagClient.notify(error, callback);
  }

  /**
   * Add custom metadata to future error reports
   */
  addMetadata(section: string, key: string, value: any) {
    this._bugsnagClient.addMetadata(section, key, value);
  }

  /**
   * Set user information for error reports
   */
  setUser(id: string, email?: string, name?: string) {
    this._bugsnagClient.setUser(id, email, name);
  }
} 